import { render, staticRenderFns } from "./FormEditPrice.vue?vue&type=template&id=d3551e7c&"
import script from "./FormEditPrice.vue?vue&type=script&lang=js&"
export * from "./FormEditPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports